import React from 'react';
import styled from 'styled-components';

export const Sticky = ({children}: React.AllHTMLAttributes<HTMLDivElement>) => {
    return <StickyContainer>{children}</StickyContainer>;
};

const StickyContainer = styled.div`
    position: sticky;
    top: 10px;
`;
